import { render } from "./Tables.vue?vue&type=template&id=c91a33ac&scoped=true"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"

import "./Tables.vue?vue&type=style&index=0&id=c91a33ac&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/CERAMICAS/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c91a33ac"]])

export default __exports__